import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
    buildConfig,
    buildGenerate,
    getBuildStatus,
    addWebhook,
    addWebhookEvent,
    eventList,
    deleteEvent,
    webhookEventList,
    getMarket,
    getSystemConfiguration,
    updateTenantProfile,
    updateBuildApplication,
    getExecutionId,
    mapDomain,
    getBuildProgress,
} from "@/services/profile";

@Module({
    namespaced: true,
})
export default class profile extends VuexModule {
    // state
    marketList = [];
    catalogTree = [];
    history = [];
    systemConfig = {};
    buildIdData = null;
    buildProgress = null;
    //action
    @Action
    public async eventList() {
        try {
            return await eventList();
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async deleteEvent(payload) {
        try {
            return await deleteEvent(payload);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async webhookEventList(payload) {
        try {
            return await webhookEventList(payload);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async addWebhook(payload) {
        try {
            return await addWebhook(payload);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async addWebhookEvent(payload) {
        try {
            return await addWebhookEvent(payload);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async buildConfig(payload) {
        try {
            return await buildConfig(payload);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async buildGenerate(payload) {
        try {
            return await buildGenerate(payload);
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async buildStatusAction(payload) {
        try {
            const data = await getBuildStatus(payload);
            this.context.commit("setHistory", data.data);
            return data.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async getSystemConfig() {
        try {
            const data = await getSystemConfiguration();
            this.context.commit("setSystemConfig", data.data.response);
            return data.data.response;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getExecutionIdAction(payload) {
        try {
            const data = await getExecutionId(payload.type, payload.id);
            this.context.commit("SET_BUILD_ID", data.data);
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getBuildProgressAction(buildId) {
        try {
            const data = await getBuildProgress(buildId);
            this.context.commit("SET_BUILD_PROGRESS", data.data);
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async clearBuildProgress() {
        try {
            this.context.commit("CLEAR_BUILD_PROGRESS");
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateTenantProfileAction(data) {
        try {
            const res = await updateTenantProfile(data.id, data.data);
            return res.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async mapDomainAction(data) {
        try {
            const res = await mapDomain(data);
            return res.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateBuildApplicationAction(data) {
        try {
            const res = await updateBuildApplication(data.id, data.data);
            return res.data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async getMarketList(userInfo: any) {
        try {
            const response = await getMarket(userInfo._id);
            return response.data;
        } catch (error) {
            console.error("Error fetching market:", error);
            throw error;
        }
    }
    // mutations
    @Mutation
    public setHistory(data: any) {
        this.history = data || [];
    }
    @Mutation
    public setSystemConfig(data: any) {
        this.systemConfig = data || [];
    }
    @Mutation
    public SET_BUILD_ID(data: any) {
        this.buildIdData = data;
    }
    @Mutation
    public SET_BUILD_PROGRESS(data: any) {
        this.buildProgress = data;
    }
    @Mutation
    public CLEAR_BUILD_PROGRESS(data: any) {
        this.buildProgress = null;
    }

    // getters
    get GetHistory() {
        return this.history;
    }
}
